import axios from "axios";
import { getAccessToken } from "./authSession";
import { API_BASE_URL } from "../config";

// Единая таблица отправителей площадки (Prom / Rozetka / Kasta).
const base = (platform, accountId) =>
    `${API_BASE_URL}/integrations/marketplaces/${platform}/accounts/${accountId}/senders`;

const auth = () => ({ headers: { Authorization: `Bearer ${getAccessToken()}` } });

export const getMarketplaceSenders = async (platform, accountId) =>
    (await axios.get(base(platform, accountId), auth())).data;

export const saveMarketplaceSenders = async (platform, accountId, items) =>
    (await axios.put(base(platform, accountId), { items }, { ...auth(), timeout: 20000 })).data;
